import { render, staticRenderFns } from "./UserGroupsActions.vue?vue&type=template&id=597178c2&scoped=true&"
import script from "./UserGroupsActions.vue?vue&type=script&lang=js&"
export * from "./UserGroupsActions.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupsActions.vue?vue&type=style&index=0&id=597178c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597178c2",
  null
  
)

export default component.exports